<div class="flex flex-col text-pet-color-text-1 items-center gap-6 md:gap-16 pb-10 px-2 md:px-6 lg:px-20">

    <span class="text-3xl w-full font-bold mt-7 md:mt-10 text-center md:text-4xl">
        Directorio de Veterinarias
    </span>

    <div class="w-full mb-20">
        <app-map-veterinarias [veterinarias]="veterinarias"></app-map-veterinarias>
    </div>
    <app-publicy-cards></app-publicy-cards>
</div>